import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/utils/utils"
import { DISABLED, FOCUS } from "@/components/ui/recipes"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-10 items-center justify-center rounded-lureo-radius bg-transparent p-1 text-lureo-ink-subtle",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      `relative isolate inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-lureo-radius-tab px-3 py-1.5 text-lureo-14 font-medium case-lureo-tab-case font-style-lureo-label-style text-shadow-lureo-label-shadow tracking-lureo-label-tracking duration-lureo-duration-slow hover:text-lureo-ink data-[state=active]:bg-transparent data-[state=active]:text-lureo-on-tab-on data-[state=active]:shadow-lureo-shadow-tab before:absolute before:inset-0 before:-z-10 before:rounded-[inherit] before:bg-lureo-tab-on before:opacity-0 before:transition-opacity data-[state=active]:before:opacity-100 [&>*]:relative [&>*]:z-10 ${FOCUS} ${DISABLED} leading-5`,
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      `mt-2 ${FOCUS}`,
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
